<template>
  <div class="all_form_block active">
    <div class="block">
      <div class="name_tools">{{ $store.getters.cv_t('CV_language') }}</div>
      <div class="all_form">
        <div class="languages_select inp_info">
          <ul>
            <li
              v-for="(language, index) in this.$store.getters.languages"
              :key="index"
              :class="{active: $store.getters.cv_locale === language.prefix}"
              @click="checkLocale(language.prefix)"
            >
              <div class="flag_icon">
                <img :src="language.flag">
              </div>
              <span>{{ language.language }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  mounted(){
    setTimeout(() => {
      this.checkLocale(this.$store.getters.cv_locale)
    },1)
  },
  watch: {
    '$store.getters.cv_locale'(to, from){
      this.checkLocale(to)
    }
  },
  methods: {
    checkLocale(locale) {
        try {
          var tmpTranslations = require("../../../../lang/" + locale);
        } catch (err) {
          return this.checkLocale(this.$store.getters.locale)
        }
        
        this.$Cookies.set("cv_locale", locale, { expires: 3 });
        this.$store.commit('cv_locale', locale);
        this.$store.commit('cv_translation', tmpTranslations );
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/js/components/pages/cv/language-tab-components/setLocale.vue